// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3BSf3","dragIcon":"Choice_dragIcon__1p8JZ","left":"Choice_left__2RfBV","input":"Choice_input__yWBGe"};